export default __webpack_public_path__ + "static/media/icon-close-qr-code-modal.10b036e3.svg";